export function getPurchaseOrderBillingIconClass(billing: string): string | null {
  switch (billing) {
    case 'pending':
      return 'icon-billing-pending';
    case 'partially_billed':
    case 'partially_paid':
      return 'icon-billing-open';
    case 'billed':
    case 'paid':
      return 'icon-billing-paid';
    default:
      return null;
  }
}

export function getPurchaseOrderDeliveryIconClass(delivery: string): string | null {
  switch (delivery) {
    case 'not_required':
      return null;
    case 'pending':
      return 'icon-delivery-pending';
    case 'partially_warehoused':
    case 'partially_shipped':
      return 'icon-delivery-open';
    case 'delivered':
    case 'warehoused':
      return 'icon-delivery-shipped';
    default:
      return null;
  }
}
